import React from 'react';
import { Outlet } from 'react-router-dom';
import LenisProvider from '../motion/LenisProvider';
import Header from '../components/site/Header';
import Footer from '../components/site/Footer';
import Grain from '../components/ui/Grain';
import IntroReveal from '../components/site/IntroReveal';

// Marketing shell. Everything under /hub and /admin renders its own shell
// (PortalLayout) and never loads Lenis/GSAP.
export default function SiteLayout() {
  return (
    <LenisProvider>
      <IntroReveal />
      <Grain />
      <Header />
      <main id="main" className="relative">
        <Outlet />
      </main>
      <Footer />
    </LenisProvider>
  );
}
